<template>
  <!-- 分享弹窗 -->
  <n-modal
    transform-origin="center"
    v-model:show="shareModal.show"
    display-directive="show"
  >
    <div class="modal_share">
      <div class="div_modal_header flex_between">
        <h3>分享</h3>
        <i class="key_icon cp_us" @click="shareModal.show = false">&#xe75c;</i>
      </div>
      <div class="div_modal_body">
        <div class="div_copy">
          <input ref="refinput" readonly type="text" :value="shareModal.url" />
          <n-button type="primary" color="#4DC6AD" @click="copyUrl()"
            >复制</n-button
          >
        </div>
        <n-qr-code
          class="qr_code"
          :title="qrCodeUrl ? qrCodeUrl : shareModal.url"
          :value="qrCodeUrl ? qrCodeUrl : shareModal.url"
          :padding="4"
          :size="134"
        />
        <p>{{ props.shareTitle }}</p>
      </div>
    </div>
  </n-modal>
</template>

<script setup>
import { ref, watch } from "vue";
import { useMessage } from "naive-ui";
import { useRoute } from "vue-router";

const route = useRoute();
const props = defineProps({
  shareUrl: {
    type: String,
    default: "",
  },
  shareTitle: {
    type: String,
    default: "扫一扫，分享此链接",
  },
  qrCodeUrl: {
    type: String,
    default: null,
  },
});
const message = useMessage();
//分享弹窗
let shareModal = ref({
  show: false,
  url: location.href,
});
let refinput = ref(null);

watch(
  () => props.shareUrl,
  (newVal) => {
    if (newVal) shareModal.value.url = newVal;
  },
  { immediate: true }
);
//分享链接复制
function copyUrl() {
  refinput.value.select();
  document.execCommand("copy");
  message.success("链接已复制");
}
function showModal() {
  shareModal.value.show = true;
}
defineExpose({ shareModal, showModal });
</script>

<style lang='scss' scoped>
// 分享弹窗
.modal_share {
  width: 480px;
  padding: 30px;
  border-radius: 15px;
  box-sizing: border-box;
  background-color: white;
  .div_modal_header {
    > h3 {
      font-weight: 500;
      font-size: 20px;
      color: #000000;
    }
    i {
      color: #9d9d9d;
    }
  }
  .div_modal_body {
    width: 100%;
    padding-top: 26px;
    text-align: center;
    .div_copy {
      width: 100%;
      height: 40px;
      border-radius: 10px 10px 10px 10px;
      overflow: hidden;
      input {
        width: 75%;
        height: 100%;
        padding: 0px 12px;
        font-size: 13px;
        cursor: text;
        border: none;
        outline: none;
        color: #73777a;
        background-color: #f6f6f7;
        box-sizing: border-box;
      }
      button {
        width: 25%;
        height: 100%;
        border-radius: 0px;
      }
    }
    .qr_code {
      margin: 20px 12px;
    }
    > p {
      font-size: 14px;
      color: #1f2328;
    }
  }
}
@media screen and (max-width: 768px) {
  // 分享弹窗
  .modal_share {
    width: 3.3rem;
    padding: 0.2rem;
    border-radius: 0.15rem;
    box-sizing: border-box;
    background-color: white;
    .div_modal_header {
      > h3 {
        font-weight: 500;
        font-size: 0.18rem;
        color: #000000;
      }
      i {
        color: #9d9d9d;
      }
    }
    .div_modal_body {
      width: 100%;
      padding-top: 0.26rem;
      text-align: center;
      .div_copy {
        width: 100%;
        height: 0.4rem;
        border-radius: 0.1rem 0.1rem 0.1rem 0.1rem;
        overflow: hidden;
        input {
          width: 75%;
          height: 100%;
          padding: 0rem 0.12rem;
          font-size: 0.13rem;
          cursor: text;
          border: none;
          outline: none;
          color: #73777a;
          background-color: #f6f6f7;
          box-sizing: border-box;
        }
        button {
          width: 25%;
          height: 100%;
          border-radius: 0rem;
        }
      }
      .qr_code {
        margin: 0.2rem 0.12rem;
      }
      > p {
        font-size: 0.14rem;
        color: #1f2328;
      }
    }
  }
}
</style>